// Runtime environment configuration helper
// Provides access to environment variables set at runtime via window.env

interface RuntimeEnv {
  VITE_BASE_URL: string;
  VITE_USE_PROXY?: string;
}

// Window.env interface already declared in other type definition files

// Fallback to build-time environment variables if runtime config is not available
const getRuntimeEnv = (): RuntimeEnv => {
  // Check if window.env is available (runtime config)
  if (typeof window !== 'undefined' && window.env) {
    const env = window.env as any;
    return {
      VITE_BASE_URL: env.VITE_BASE_URL || env.API_URL || import.meta.env.VITE_BASE_URL || 'http://localhost:4000',
      VITE_USE_PROXY: env.VITE_USE_PROXY || import.meta.env.VITE_USE_PROXY || 'false',
    };
  }

  // Fallback to build-time environment variables
  return {
    VITE_BASE_URL: import.meta.env.VITE_BASE_URL || 'http://localhost:4000',
    VITE_USE_PROXY: import.meta.env.VITE_USE_PROXY || 'false',
  };
};

const runtimeEnv = getRuntimeEnv();

// Helper functions to derive specific URLs from base URL
export const getApiUrl = (): string => {
  // If proxy is enabled, use relative URLs (nginx will proxy to backend)
  if (runtimeEnv.VITE_USE_PROXY === 'true') {
    return '/api';
  }
  // Otherwise use full backend URL
  return `${runtimeEnv.VITE_BASE_URL}/api`;
};

export const getWebSocketUrl = (): string => {
  // If proxy is enabled, use relative URLs (nginx will proxy to backend)
  if (runtimeEnv.VITE_USE_PROXY === 'true') {
    return window.location.origin;
  }
  // Otherwise use full backend URL
  return runtimeEnv.VITE_BASE_URL;
};

// For backward compatibility
export const runtimeEnvCompat = {
  VITE_API_BASE_URL: getApiUrl(),
  VITE_SOCKET_URL: getWebSocketUrl(),
  VITE_WEBSOCKET_URL: getWebSocketUrl(),
};

export { runtimeEnv };